import { HUB_ACCESS_HEADER } from '@/config/env';

export const HUB_ACCESS_HEADER_NAME = 'X-Hub-Access';

// Every request to the hub carries this so the ALB rule lets it through.
export function applyHubAccessHeader(headers: Headers): Headers {
    if (HUB_ACCESS_HEADER) headers.set(HUB_ACCESS_HEADER_NAME, HUB_ACCESS_HEADER);
    return headers;
}
